<template lang="pug">
div.SINGLETEXT.Absolutely-Centralization
  .title  {{cont.title}}
  .content {{cont.stem}}
  button(@click='Ook')  我知道啦
</template>

<script>
export default {
  props: ["cont"],
  created() {
    this.$nextTick(() => {
      console.log(this.cont);
    });
  },
  methods: {
    Ook() {
      /** 我知道了按钮 */
      this.$emit("Ook");
    }
  }
};
</script>

<style lang="stylus" scoped>
.SINGLETEXT
  position fixed
  width 800px
  height 302px
  background rgba(255, 255, 255, 1)
  border-radius 4px
  z-index 100
  text-align left
  padding 40px 32px
  .title
    font-size 20px
    font-family MicrosoftYaHeiUI-Bold
    font-weight bold
    color rgba(42, 46, 54, 0.8)
    line-height 25px
  .content
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 28px
    margin-top 24px
    height 120px
    overflow auto
    margin-bottom 20px
  button
    width 126px
    height 40px
    background rgba(58, 118, 210, 1)
    border-radius 4px
    border none
    outline none
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(255, 255, 255, 1)
    line-height 18px
    float right
</style>
